import React from 'react'
import { useAtomValue } from 'jotai'
import { customerModelAtom } from './atoms/customersAtoms'
import { CustomersList } from './CustomersList/CustomersList'

export const Customers = () => {
  const customerModel = useAtomValue(customerModelAtom)

  if (customerModel) return <CustomersList customerModel={customerModel} />
  return <></>
}
